
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      sizeList: [
        {
          title: "2",
          value: 2,
        },
        {
          title: "4",
          value: 4,
        },
        {
          title: "6",
          value: 6,
        },
        {
          title: "8",
          value: 8,
        },
        {
          title: "10",
          value: 10,
        },
        {
          title: "12",
          value: 12,
        },
        {
          title: "14",
          value: 14,
        },
        {
          title: "16",
          value: 16,
        },
        {
          title: "18",
          value: 18,
        },
        {
          title: "20",
          value: 20,
        },
        {
          title: "22",
          value: 22,
        },
        {
          title: "24",
          value: 24,
        },
        {
          title: "26",
          value: 26,
        },
        {
          title: "28",
          value: 28,
        },
        {
          title: "30",
          value: 30,
        },
      ],

      colors: [
        {
          title: "خاکسنری",
          value: "state",
        },
        {
          title: "قرمز",
          value: "red",
        },
        {
          title: "نارنجی",
          value: "orange",
        },
        {
          title: "زرد",
          value: "yellow",
        },
        {
          title: "سبز",
          value: "green",
        },
        {
          title: "خاکستری",
          value: "gray",
        },
        {
          title: "آسمانی",
          value: "sky",
        },
        {
          title: "آبی",
          value: "blue",
        },
        {
          title: "بنفش",
          value: "purple",
        },
        {
          title: "صورتی",
          value: "pink",
        },
        {
          title: "مشکی",
          value: "black",
        },
        {
          title: "سفید",
          value: "white",
        },
      ],
    };
  },
  methods: {
    submitProduct() {
      store.dispatch("admin/createLandingProduct", {
        image: this.chosenFile,
        images: this.chosenFiles,
      });
    },
    uploadImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateLandingProductImage",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
  },
  computed: {
    categories(): any[] {
      const categories = store.state.admin.landing.categories;
      const subCategories = store.state.admin.landing.subCategories;

      let items: any[] = [];
      categories.forEach((category: any) => {
        const item = {
          title: category.persianTitle,
          value: category._id,
        };
        items.push(item);
      });

      subCategories.forEach((category: any) => {
        const item = {
          title: category.persianTitle,
          value: category._id,
        };
        items.push(item);
      });
      return items;
    },

    subCategories(): any[] {
      const subCategories = store.state.admin.landing.subCategories;
      let items: any[] = [];
      subCategories.forEach((subCategories: any) => {
        const item = {
          title: subCategories.persianTitle,
          value: subCategories._id,
        };
        items.push(item);
      });
      return items;
    },

    // totalList() {
    //   var test = [];
    //   text.push(this,)
    //   const total = this.categories + this.subCategories;
    //   return total
    // },

    types(): any[] {
      const types = store.state.admin.landing.types;
      let items: any[] = [];
      types.forEach((category: any) => {
        const item = {
          title: category.title,
          value: category._id,
        };
        items.push(item);
      });
      return items;
    },
    name: {
      get(): string {
        return store.state.admin.landing.productData.name;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductName", value);
      },
    },
    nameError(): string[] {
      const errors: string[] = [];
      if (!this.$v.name?.$dirty) {
        return errors;
      }
      !this.$v.name.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    size: {
      get(): string {
        return store.state.admin.landing.productData.sizes;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductSize", value);
      },
    },
    sizeError(): string[] {
      const errors: string[] = [];
      if (!this.$v.size?.$dirty) {
        return errors;
      }
      !this.$v.size.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    color: {
      get(): string {
        return store.state.admin.landing.productData.colors;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductColor", value);
      },
    },
    colorError(): string[] {
      const errors: string[] = [];
      if (!this.$v.color?.$dirty) {
        return errors;
      }
      !this.$v.color.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    category: {
      get(): string {
        return store.state.admin.landing.productData.category;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductCategory", value);
      },
    },
    categoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.category?.$dirty) {
        return errors;
      }
      !this.$v.category.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    type: {
      get(): string {
        return store.state.admin.landing.productData.type;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductType", value);
      },
    },
    typeError(): string[] {
      const errors: string[] = [];
      if (!this.$v.type?.$dirty) {
        return errors;
      }
      !this.$v.type.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    amount: {
      get(): number | null {
        return Number(store.state.admin.landing.productData.amount);
      },
      set(value: number): void {
        store.dispatch("admin/updateLandingProductAmount", Number(value));
      },
    },
    amountError(): string[] {
      const errors: string[] = [];
      if (!this.$v.amount?.$dirty) {
        return errors;
      }
      !this.$v.amount.minLength && errors.push("حداقل 4 رقم");
      !this.$v.amount.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    description: {
      get(): string {
        return store.state.admin.landing.productData.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },

  validations: {
    name: {
      required,
    },
    size: {
      required,
    },
    color: {
      required,
    },
    category: {
      required,
    },
    type: {
      required,
    },
    amount: {
      required,
      minLength: minLength(4),
    },
    description: {
      required,
    },
  },

  created() {
    store.dispatch("admin/getAllCategories");
    store.dispatch("admin/getLandingSubCategories");
  },
});
